import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Experiences } from '@app/profile/profile-api.model';
import { UserPosition } from '@app/inputs/inputs-api.model';
import { TranslateService } from '@ngx-translate/core';
import { catchAndSurfaceError } from '@app/shared/utils';
import { NgxHttpClient } from '@app/shared/ngx-http-client';

@Injectable({
  providedIn: 'root',
})
export class ProfileExperiencesService {
  constructor(
    private translate: TranslateService,
    private http: NgxHttpClient
  ) {}

  /**
   * Gets the sorted experiences based on date completed. Can pass through tag id to get experiences with particular skill
   *
   * @param userKey - The key for the user
   * @param count - How many experiences to return
   * @param skip - How many experiences already loaded.
   * @param tagId (Optional) - get experiences that have this tagName associated with them if supplied
   */
  public getPublicSortedUserPositions(
    userKey: number,
    count: number,
    skip: number,
    tagId: number = null
  ): Observable<Experiences> {
    return this.http
      .get<Experiences>('/userinputs/GetPublicSortedUserPositions', {
        params: {
          userKey: userKey,
          count: count,
          skip: skip,
          tagId: tagId,
        },
      })
      .pipe(
        catchAndSurfaceError(
          this.translate.instant('UserProfileSvc_ProblemAccessingCollection')
        )
      );
  }

  /**
   * Get the full details for an experience.
   *
   * @param userPositionId - The id for the experience to retrieve
   * @param userGuid - The GUID id of the user being requested.
   */
  public getExperienceDetails(
    userPositionId: number,
    userGuid: string
  ): Observable<UserPosition> {
    return this.http
      .get('/userinputs/getpublicuserposition', {
        params: {
          userPositionId,
          userGuid,
        },
      })
      .pipe(
        catchAndSurfaceError(
          this.translate.instant('UserProfileSvc_ProblemAccessingCollection')
        )
      );
  }
}
